// extracted by mini-css-extract-plugin
module.exports = {"container":"clause-section_container__a0uBP","title":"clause-section_title__8L66L"};